class SearchTabStore extends FluxBaseStore
  @storeName: 'SearchTabStore'

  @handlers:
    RECEIVED_SEARCH_TABS: 'receivedSearchTabs'

  receivedSearchTabs: (tabs) ->
    @_searchTabs = {}
    for tab in tabs
      @_searchTabs[tab.id] = tab
      @_defaultTabId = tab.id if tab.default
    @emit("change")

  get: (id) ->
    @_searchTabs[id]

  getAll: ->
    @_searchTabs

LP.module('Searches').SearchTabStore = SearchTabStore
